import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/SignIn.css";
import { apiPost } from "../../../api";

import studentSignIn from "../../../images/student-signin.png";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      const res = await apiPost("/auth/signin", { email, password });
      localStorage.setItem("accessToken", res.accessToken);
      sessionStorage.setItem("refreshToken", res.refreshToken);
      window.location.href = "/app/react/home";
    } catch (err) {
      setMsg(err.message || "Failed to sign in");
      setLoading(false);
    }
  };

  return (
    <div className="signin-page">
      <img
        src={studentSignIn}
        alt="Sign in illustration"
        className="signin-illustration"
      />

      <div className="signin-box auth-card">
        <h2 className="signin-title">Sign In</h2>

        <form className="signin-form" onSubmit={handleSubmit}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="yourname@my.yorku.ca"
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
          />

          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Sign In"}
          </button>
        </form>

        {msg && <div className="msg error">{msg}</div>}

        <div className="signin-links">
          <p>
            Forgot password?{" "}
            <Link to="/auth/react/forgot-password" className="link">
              Reset it
            </Link>
          </p>
          <p>
            Don't have an account?{" "}
            <Link to="/auth/react/register" className="link">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}